import { MMKV } from 'react-native-mmkv'

export const STORAGE = new MMKV()


// export

export const addToStorage = ({key, data}:{key: string, data: ({[key: string]: any}) | string}) => {
    try{
        STORAGE.set(key, JSON.stringify(data))
    }catch(e){
        console.error('addToStorage', e)
        return false
    }
    return true
}

export const getFromStorage = ({key}: {key: string}) : Object | null => {
    const data = STORAGE.getString(key);
    try{
        if(data){
            return JSON.parse(data)
        }  
    }catch(e){
        console.error('getFromStorage', e)
    }
     
    return null
}


export const removeFromStorage = ({key}: {key: string}) => {
    try{
        STORAGE.delete(key)
    }catch(e){
        console.error('addToStorage', e)
        return false
    }
    return true
}



export const stateUpdateWithStorage = ({key, data, setData}
    : {key : string, data: Object | string | any, setData: (x: any) => any }
) => {
    if(data){
          addToStorage({key: key, data: data})
        }else {
          removeFromStorage({key: key})
        }
        setData(data)
}